const STORAGE_KEY = 'eagle_sidebar_drawer_by_path';

function readMap() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed;
    }
  } catch (_) {}
  return {};
}

/**
 * @param {string} pathname
 * @returns {boolean|undefined}
 */
export function getDrawerOpenForPath(pathname) {
  if (!pathname) return undefined;
  try {
    const map = readMap();
    const v = map[pathname];
    if (typeof v === 'boolean') return v;
  } catch (_) {}
  return undefined;
}

/**
 * @param {string} pathname
 * @param {boolean} open
 */
export function setDrawerOpenForPath(pathname, open) {
  if (!pathname) return;
  try {
    const map = readMap();
    map[pathname] = Boolean(open);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (_) {}
}

export function isTemplateEditorPath(pathname) {
  if (!pathname) return false;
  return /^\/catalogs\/templates\/(new|[^/]+\/edit)$/.test(pathname);
}
